import moment from 'moment';
import { translate } from '@components/i18n';
import { formatMoney } from '@utils/money';
import { useSelector } from 'react-redux';
import { moneySymbolsSelector } from '@redux/slices/money-type';

export const columns = [
    {
        title: translate('columns.client'),
        dataIndex: 'razaoSocial',
        sorter: true,
        width: '30%',
    },
    {
        title: translate('columns.date'),
        dataIndex: 'dataPedido',
        sorter: false,
        width: '30%',
        render: (_, record): React.ReactNode => {
            return (
                <span>
                    {moment(record.dataPedido).format('DD/MM/YYYY')}
                </span>
            );
        },
    },
    {
        title: translate('columns.total'),
        dataIndex: 'total',
        sorter: false,
        width: '40%',
        render: (_, record): React.ReactNode => {
            const total = record?.pedidoItens?.reduce((prev, current) => prev + current.precoTotal, 0)
            const moneyCode = record.codigoMoeda
            const symbols = useSelector(moneySymbolsSelector)
            const symbol = symbols.find(item => item.codigoMoeda === moneyCode)

            return (
                <span
                    style={{
                        display: 'flex',
                        columnGap: '5px',
                        userSelect: 'none',
                    }}
                >
                    {formatMoney(symbol?.simbolo, total || 0)}
                </span>
            );
        },
    },
];

export const filterTypes = [
    {
        name: 'TODOS',
        description: translate('filters.all'),
    },
    {
        name: 'CNPJ',
        description: translate('filters.cnpj'),
    },
    {
        name: 'NOME',
        description: translate('filters.name'),
    },
    {
        name: 'PROMOTOR',
        description: translate('filters.promoterCode'),
    },
];

export const filterTypesOrder = [
    {
        name: 'CNPJ_CLIENTE',
        description: translate('filters.cnpj'),
    },
    {
        name: 'RAZAO_SOCIAL',
        description: translate('filters.name'),
    },
    {
        name: 'CODIGO_CLIENTE',
        description: translate('filters.clientCode'),
    },
    {
        name: 'CIDADE_CLIENTE',
        description: translate('filters.city'),
    },
    {
        name: 'ZONA_CLIENTE',
        description: translate('filters.state'),
    },
    {
        name: 'TIPO_PEDIDO',
        description: translate('filters.orderType'),
    },
];

export const filterTypesOrderHistory = [
    {
        name: 'CNPJ_CLIENTE',
        description: 'CNPJ',
    },
    {
        name: 'NOME_CLIENTE',
        description: 'Nome',
    },
    {
        name: 'PEDIDO',
        description: 'Pedido',
    },
    {
        name: 'CODIGO_CLIENTE',
        description: 'Código do Cliente',
    },
    {
        name: 'CIDADE_CLIENTE',
        description: 'Cidade',
    },
    {
        name: 'ZONA_CLIENTE',
        description: 'Estado',
    },
    {
        name: 'TIPO_PEDIDO',
        description: 'Tipo de Pedido',
    },
];

export const filterOptions = [
    { value: 'all', label: 'Todos' },
    { value: 'name', label: 'Nome' },
    { value: 'code', label: 'Código' },
];